import { FormControl, FormGroup } from '@angular/forms';
import { ILesson } from '@internal-models/lesson.model';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { format, set } from 'date-fns';

export type ILessonForm = {
	name: string;
	description: string;
	startsAt: Date;
	startTime: string;
	endTime: string;
};

export class LessonFormFactory {
	public static create(lesson?: ILesson): IFormGroup<ILessonForm> {
		return new FormGroup({
			id: new FormControl(lesson?.id),
			name: new FormControl(lesson?.name, [SharedFormValidators.required]),
			description: new FormControl(lesson?.description),
			startsAt: new FormControl(
				lesson?.CalendarEvent.startsAt ? new Date(lesson?.CalendarEvent.startsAt) : null,
				[SharedFormValidators.required, SharedFormValidators.date]
			),
			startTime: new FormControl(
				lesson?.CalendarEvent.startsAt ? format(new Date(lesson?.CalendarEvent.startsAt), 'HH:mm') : null,
				[SharedFormValidators.required]
			),
			endTime: new FormControl(
				lesson?.CalendarEvent.endsAt ? format(new Date(lesson?.CalendarEvent.endsAt), 'HH:mm') : null,
				[SharedFormValidators.required]
			),
		}) as IFormGroup;
	}

	public static getValue(form: IFormGroup<ILessonForm>): ILesson {
		const [startHours, startMinutes] = form.value.startTime.split(':');
		const [endHours, endMinutes] = form.value.endTime.split(':');
		return {
			...form.value,
			CalendarEvent: {
				startsAt: set(form.value.startsAt, {
					hours: parseInt(startHours),
					minutes: parseInt(startMinutes),
					seconds: 0,
				}).toISOString(),
				endsAt: set(form.value.startsAt, {
					hours: parseInt(endHours),
					minutes: parseInt(endMinutes),
					seconds: 0,
				}).toISOString(),
			},
		} as unknown as ILesson;
	}
}
